<template>
	<div class="about-page-wrapper">
		<transition appear name="fadeslow">
			<div class="menu-layer">
				<navigation :darken="true"></navigation>
			</div>
		</transition>

		<div class="empty-block"></div>

		<transition appear name="fade">
			<div class="about-content-wrapper">
				<h2>Contact</h2>
				<p>
					If you need a photographer and my work touches or inspires you, please feel free to reach out to me.
					<br>
					I'm based in Stockholm, Sweden.
				</p>
				<p>
					<a href="mailto:roberto@tabi.se">email: roberto@tabi.se</a>
				</p>
			</div>
		</transition>

		<div class="image-wrapper">
			<img src="../assets/contact-image.jpg">
		</div>

		<div class="about-content-wrapper">
			<div class="quote">
				Pleasure in the job puts perfection in the work.<br>
				-Aristotle
			</div>
		</div>


	</div>
</template>

<script>

	import Navigation from "./Navigation.vue";

	export default {
		name: "AboutPage",
		components: {
			Navigation
		},
		data () {
			return {
				welcomeText: 'TABI PHOTOGRAPHY'
			}
		}
	}

</script>

<style scoped>

	.about-page-wrapper {
		background-color: #282828;
	}

	.empty-block {
		padding-top: 3.5rem;
	}

	.about-content-wrapper {
		padding: 2rem;
		padding-top: 0.5rem;
	}

	.menu-layer {
		position: fixed;
		top: 0;
		width: 100%;
	}

	h1 {
		font-size: 1.2rem;
		text-align: left;
		color: #fff;
		margin: 1rem 0 0.5rem 1rem;
		font-weight: 100;
	}

	h2 {
		font-size: 1.2rem;
		text-align: left;
		color: #fff;
		margin: 1rem 0 0.5rem 0rem;
		font-weight: 100;
	}

	p {
		font-size: 0.8rem;
		text-align: justify;
		color: #fff;
		margin: 1rem 0 0.5rem 0rem;
		font-weight: 100;
	}

	a, a:link, a:visited {
		font-size: 0.8rem;
		text-align: left;
		display: inline;
		color: #fff;
		margin: 0rem 0 0.5rem 0rem;
		font-weight: 100;
		text-decoration: none;
	}

	a:hover {
		text-decoration: underline;
	}

	a:active {
		text-decoration: underline;
	}

	.quote {
		padding: 0 0 0 0;
		font-size: 0.8rem;
		color: #fff;
		margin: 0rem 0rem 1rem 0rem;
		font-weight: 100;
		font-style: italic;
		text-align: right;
	}

	.image-wrapper {
		margin: 0 2rem;
		padding: 0;
	}

	img {
		width: 100%;
		height: auto;
	}

	@media only screen and (min-width: 600px) {
		.about-content-wrapper {
			padding: 1rem 6rem;
		}

		.image-wrapper {
			padding: 0 4rem;
		}

		h1 {
			font-size: 2rem;
		}

		h2 {
			font-size: 1.5rem;
		}

		p {
			font-size: 1rem;
		}
	}

</style>


<!--

<style lang="scss" scoped>

	.quote {
		padding: 0 2rem;
		font-size: 0.8rem;
		color: #fff;
		margin: 0rem 0rem 1rem 0rem;
		font-weight: 100;
		font-style: italic;

		p {
			margin: 0;
			text-align: right;
		}
	}

	.image-wrapper {
		margin: 0 2rem;
		padding: 0;
	}

	img {
		width: 100%;
		height: auto;
	}

	@media only screen and (min-width: 600px) {
		.about-content-wrapper {
			padding: 1rem 6rem;
		}

		.image-wrapper {
			padding: 0 4rem;
		}

		h1 {
			font-size: 2rem;
		}

		h2 {
			font-size: 1.5rem;
		}

		p {
			font-size: 1rem;
		}
	}

</style>
-->


// WEBPACK FOOTER //
// src/components/ContactPage.vue